<template>
  <notifications
    group="notifications"
    :position="'top right'"
  >
    <template
      #body="props"
    >
      <div
        :class="[props.item.type]"
        class="notification"
      >
        <div class="icon" />
        <div>{{ props.item.text }}</div>
      </div>
    </template>
  </notifications>
</template>

<script>

export default {

};
</script>

<style lang='scss' scoped>

</style>
